<div class="container">
  <app-search-and-filter></app-search-and-filter>
</div>

<app-spinner [isLoading]="isInitialLoading$ | async" [isWithSearchPanel]="true">
  @if ({
    topBanner: frontPageTopBanner$ | async,
    midBanner: frontPageMidBanner$ | async,
    midBanner2: frontPageMidBanner2$ | async,
    bottomBanner: frontPageBottomBanner$ | async,
    isLoading: isLoading$ | async,
    isLoadingMore: isLoadingMore$ | async,
    vipAnnouncements: vipAnnouncements$ | async,
    currentPage: currentPage$ | async,
    mergedAnnouncements: mergedAnnouncements$ | async,
    isCvBoxSliderVisible: isCvBoxSliderVisible$ | async,
    hasMorePages: selectHasMorePages$ | async,
    userType: userType$ | async
  }; as data) {
    <div
      infinite-scroll
      [infiniteScrollDisabled]="data.isLoading || !data.hasMorePages"
      [infiniteScrollDistance]="0"
      (scrolled)="onScrollDown(data.hasMorePages, data.currentPage)"
      class="content"
    >
      <!-- Top Banner -->
      <div class="banner">
        <app-banner
          [banner]="data.topBanner"
          [pageId]="pageId.FrontPage"
        ></app-banner>
      </div>

      <!-- Vip Cv Ann -->
      <div class="announcement section section--vip-cv-announcement">
        @for (announcement of vipCvAnnouncements$ | async; track announcement.announcementId) {
          <app-announcement-item
            [announcement]="announcement"
            [pageName]="pageName.FrontPage"
            [date]="date"
            [userType]="data.userType"
            [providerWebsiteId]="providerWebsiteId"
          ></app-announcement-item>
        }
      </div>

      <!-- Mid Banner -->
      <div class="banner">
        <app-banner
          [banner]="data.midBanner"
          [pageId]="pageId.FrontPage"
        ></app-banner>
      </div>

      <!--Vip CV BOX SECTION-->
      @let vipCvBoxes = vipCvBoxes$ | async;
      @if (vipCvBoxes?.length) {
        <div class="section cv-box section--vip-cv-box">
          @for (cvBox of vipCvBoxes; track cvBox.customerId) {
            <app-cv-box-item
              [cvBox]="cvBox"
              [userType]="data.userType"
            ></app-cv-box-item>
          }
        </div>
      }

      <!--Vip Ann-->
      <div class="search-results-container">
        @for (announcement of data.vipAnnouncements; track announcement.announcementId) {
          <app-announcement-item
            [announcement]="announcement"
            [pageName]="pageName.FrontPage"
            [date]="date"
            [userType]="data.userType"
            [providerWebsiteId]="providerWebsiteId"
          ></app-announcement-item>
        }
      </div>

      <!-- Mid Banner 2 -->
      <div class="banner">
        <app-banner
          [banner]="data.midBanner2"
          [pageId]="pageId.FrontPage"
        ></app-banner>
      </div>

      <!--Premium CV BOX SECTION-->
      @if (data.isCvBoxSliderVisible) {
        <div class="section slider">
          <owl-carousel-o [options]="cvBoxSliderOptions" class="carousel">
            @for (cvBox of premiumCvBoxes$ | async; track cvBox.customerId) {
              <ng-template carouselSlide [id]="cvBox.customerId">
                <app-cv-box-item
                  ngxSlickItem
                  [cvBox]="cvBox"
                  class="cv-box-slider__item"
                  [userType]="data.userType"
                ></app-cv-box-item>
              </ng-template>
            }
          </owl-carousel-o>
        </div>
      }

      <div class="search-results-container">
        @for (announcement of data.mergedAnnouncements; track announcement.announcementId) {
          <app-announcement-item
            [announcement]="announcement"
            [pageName]="pageName.FrontPage"
            [date]="date"
            [userType]="data.userType"
            [providerWebsiteId]="providerWebsiteId"
          ></app-announcement-item>
        }
      </div>

      <!-- Infinite scroll: next page loading -->
      @if (data.isLoadingMore) {
        <div class="load-more-spinner" role="status" aria-live="polite">
          <svg-icon
            class="load-more-spinner__icon"
            src="/assets/icons/spinner.svg"
            aria-hidden="true"
          ></svg-icon>
        </div>
      }

      @if (isFrontPageLinkVisible$ | async) {
        <div class="view-all-announcements">
          <a [routerLink]="['./search-posting']" class="view-all-announcements__link">
            {{ 'label.ViewAllAnnouncements' | translate }}
            <svg-icon
              class="view-all-announcements__icon"
              src="/assets/icons/arrow-right.svg"
              aria-hidden="true"
            ></svg-icon>
          </a>
        </div>
      }

      <!--City links SECTION-->
      <div class="locality-links">
        @for (item of selectFrontPageCityLinks$ | async; track item.localityId) {
          <a
            [routerLink]="['/search-posting/']"
            [queryParams]="item.queryParams"
            class="locality-links__item"
          >{{ item.name }}</a>
        }
      </div>

      <!-- Bottom Banner -->
      <div class="banner">
        <app-banner
          [banner]="data.bottomBanner"
          [pageId]="pageId.FrontPage"
        ></app-banner>
      </div>
    </div>
  }
</app-spinner>
